var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    ' px-4 py-2 transition duration-300',
    _vm.active ? 'bg-[#4F4F51] text-white' : 'bg-white text-[#4F4F51]',
  ],on:{"click":function($event){return _vm.clickFunction(_vm.view)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }